
import { Box } from '@mui/material';
import { useTheme } from '@mui/material';
import { useUser } from '../context/useUser';
import { PageHeader } from '../components/UserList/PageHeader';
import { UserTable } from '../components/UserList/UserTable';
import { ErrorSnackbar } from '../components/UserList/ErrorSnackbar';


export default function UserListPage() {
  const theme = useTheme();
  const { 
    users, 
    isLoading, 
    error, 
    handleCreate, 
    handleView, 
    handleCloseError 
  } = useUser();
 


  return (
    <>
      <ErrorSnackbar error={error} onClose={handleCloseError} />

      <Box style={{ 
        background: theme.palette.background.paper, 
        borderRadius: 16, 
        padding: 32, 
        boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)', 
        maxWidth: '100%', 
        margin: '0 auto' 
      }}>
        <PageHeader onCreate={handleCreate} isLoading={isLoading} />
        <UserTable
          users={users}
          isLoading={isLoading}
          onView={handleView}
        />
      </Box>
    </>
  );
}